import * as libOrganization from './organization';
const prefix = 'generalMeetings/';
export const IDToName = ({ organizationID, generalMeetingID }) => {
    return libOrganization.IDToName({ organizationID }) + '/' + prefix + generalMeetingID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 4) {
        throw new Error(`bad general meeting name: ${name}`);
    }
    return {
        organizationID: parts[1],
        generalMeetingID: parts[3],
    };
};
